module.exports = __webpack_public_path__ + "img/empty.4c0dff58.png";